export const I18n = {
    'en': {
        personPackages_title: 'Packages',
        install: 'Install',
        apps: 'Apps'
    },
    'ru': {
        personPackages_title: 'Пакеты',
        install: 'Установка',
        apps: 'Приложения'
    },
    'sk': {
        personPackages_title: 'Balíčky',
        install: 'Inštalácia',
        apps: 'Aplikácie'
    }
};



// WEBPACK FOOTER //
// ./src/I18n/components/person/index.js